/* Stylesheet */

.form_input {
  display: flex;
  align-items: center;
  font-size: 0.938rem;
  border-radius: 52px;
  background: var(--ion-background-secondary);
  box-shadow: var(--ion-box-shadow);

  .icon_container {
    display: flex;
    height: 48px;
    width: 72px;
    align-items: center;
    justify-content: center;

    .icon {
      height: 21px;
      width: 21px;
    }
  }
}

.error_message {
  display: flex;
  margin: 0px 21px 21px 0px;
  justify-content: flex-end;
  font-size: 12px;
  color: var(--ion-color-error);
}
